// Round edits stay in memory until the parent explicitly saves this draft.
export function lineupPeople(draft) {
  return (draft.eligibleMembers || []).filter(p => Number(p.isLeader) !== 1 && !['领队', '教练'].includes(p.racePosition))
}

export function moveLineupMember(draft, memberId, destination) {
  const person = lineupPeople(draft).find(p => Number(p.memberId) === Number(memberId))
  if (!person) throw new Error('仅可调整本次已报名的运动员')
  const id = person.memberId
  const seats = draft.seats.map(s => ({ ...s }))
  const oldIndex = seats.findIndex(s => Number(s.memberId) === Number(id))
  let alternates = draft.alternates.filter(item => Number(item) !== Number(id))
  if (destination !== 'pool' && destination !== 'alternate') {
    const index = Number(destination)
    if (!Number.isInteger(index) || index < 0 || index >= seats.length) throw new Error('座位不存在')
    if (person.racePosition !== draft.seatRoles[index]) throw new Error(`该座位需要${draft.seatRoles[index]}`)
    const displaced = seats[index].memberId
    // Compatible occupied seats swap; replacement from the pool returns the old occupant to the pool.
    if (oldIndex >= 0) seats[oldIndex].memberId = displaced || null
    seats[index].memberId = id
  } else {
    if (destination === 'alternate') {
      const limit = draft.substituteMode === 'UNLIMITED' ? Infinity : Number(draft.substituteLimit || 0)
      if (draft.substituteMode === 'NONE' || alternates.length >= limit) throw new Error('已达到本组别的替补上限')
      alternates.push(id)
    }
    if (oldIndex >= 0) seats[oldIndex].memberId = null
  }
  return { ...draft, seats, alternates }
}

export function lineupRows(draft) {
  let cursor = 0
  const people = lineupPeople(draft)
  return (draft.boatSeatRows || []).map((count, row) => ({ row: row + 1, seats: Array.from({length:Number(count)}, (_, side) => {
    const index = cursor++
    return { index, role: draft.seatRoles[index], side: Number(count) === 1 ? '中间' : side === 0 ? '左' : '右',
      person: people.find(p => Number(p.memberId) === Number((draft.seats[index] || {}).memberId)) }
  }) }))
}
